var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 23C5.14872 23 0 17.8513 0 11.5C0 5.14872 5.14872 0 11.5 0C17.8513 0 23 5.14872 23 11.5C23 17.8513 17.8513 23 11.5 23ZM15.0902 10.1345L13.6397 10.1402L13.6307 8.7948L15.0902 8.80415V7.37527L13.6211 7.34563L13.6104 5.74928H12.1714L12.18 7.32599H10.7989L10.8219 5.74928H9.3685L9.37906 7.32851L7.9381 7.37527V8.85338L9.35404 8.85693L9.38872 10.1807L7.9381 10.1837V11.6619L9.40794 11.6585L9.41783 13.1401H10.8392L10.8482 11.6126H12.18L12.2035 13.1401H13.6598L13.6495 11.6069L15.0902 11.6126V10.1345ZM16.6192 13.9284C13.3323 17.9216 8.44248 16.7582 6.3104 13.8298C5.62916 12.8942 3.88462 13.4018 4.97865 15.0124C8.11725 19.633 15.2512 19.2275 18.0496 15.0124C19.0167 13.5556 17.5972 12.7402 16.6192 13.9284ZM10.8392 8.86062L12.1515 8.86389L12.1602 10.1749L10.8738 10.1776L10.8392 8.86062Z",
    fill: "#01B0EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupme);
export default __webpack_public_path__ + "static/media/groupme.c69369041142f6f89a9fc492288c005e.svg";
export { ForwardRef as ReactComponent };